import { useLocation } from "react-router-dom";
import useGTM from "../hooks/useGTM";
import { GTM_CONFIG } from "../config/gtmConfig";
// import { useEffect } from "react";
// import { pushDataLayer } from "../utils/dataLayer";

const GTMProvider = () => {
  const { pathname } = useLocation();

  // Find the GTM ID that matches the current path
  const matched = GTM_CONFIG.find((config) => config.paths?.includes(pathname));

  useGTM("GTM-MD4CWRKW");

  return null;
};

export default GTMProvider;
